import { render } from "./MyIngredients.vue?vue&type=template&id=181def18&scoped=true"
import script from "./MyIngredients.vue?vue&type=script&lang=js"
export * from "./MyIngredients.vue?vue&type=script&lang=js"

import "./MyIngredients.vue?vue&type=style&index=0&id=181def18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181def18"]])

export default __exports__